import { createElement } from "react";
import filterProps from "./filter-props";
// Create HTML element without any theme relevant properties
// unfortunately the "props" is not type safe...
export const createNativeElement = (tag, props, ref) => createElement(tag, Object.assign(Object.assign({}, filterProps(props)), { ref }));
